import { execAdmin } from '@src/apis/reware/utils';
import type {
  UpdatePricingRuleMutation,
  UpdatePricingRuleMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

export const updatePricingRule = async ({
  partnerId,
  ruleId,
  updates,
}: UpdatePricingRuleMutationVariables) => {
  const query = gql`
    mutation updatePricingRule(
      $partnerId: Int!
      $ruleId: Int!
      $updates: PricingRuleUpdateInput!
    ) {
      partner(id: $partnerId) {
        updatePricingRule(
          ruleId: $ruleId
          updates: $updates
        ) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<UpdatePricingRuleMutationVariables, UpdatePricingRuleMutation>(
    query,
    { variables: { partnerId, ruleId, updates } }
  );

  const result = data.partner?.updatePricingRule;
  if (!result) {
    throw new Error(
      `updatePricingRule: unexpected response — partner.updatePricingRule is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return result;
};
